const popups = {};

function importAll(context) {
  context.keys().forEach(key => (popups[key] = context(key)));
}

importAll(require.context('../../../core/popups', true, /\.(html)$/));

angular
  .module('cfn')
  .directive('cfnSelectMultiReference', cfnSelectMultiReference);

cfnSelectMultiReference.$inject = ['$rootScope', 'i18nFilter', 'pathFilter'];
function cfnSelectMultiReference($rootScope, i18nFilter, pathFilter) {
  var template =
    '<span class="popover-btn">' +
    '<span ng-repeat="type in types">' +
    '<button type="button" id="{{type.id}}" ng-style="{display:($index>0) && \'none\' || \'block\'}"  popover-append-to-body="true" popover-result="onResult" popover-animation="true" popover-titletext="{{ type.title }}" popover-titlelink="{{type.links}}" popover-placement="bottom" data365-popover="{{ type.popover }}" class="btn popover-btn {{class}}" ng-transclude="">' +
    '</button></span></span>';

  return {
    restrict: 'E',
    scope: {
      result: '&',
      class: '@',
      readonly: '=',
      multiselect: '@',
      title: '@',
      type: '@',
      aggregatedAdd: '@',
      required: '@',
      pathExt: '@',
      serviceParam: '@'
    },
    transclude: true,
    replace: true,
    template: template,
    link: link
  };

  function link(scope, element, attrs) {
    scope.$rootScope = $rootScope;
    scope.allowMultiSelect = scope.multiselect == 'true';
    scope.aggregatedAdd = scope.aggregatedAdd == 'true';
    var types = scope.type.split(',');
    scope.types = [];
    for (var i in types) {
      const [name] = types[i].split(':');
      let popover = popups[`./${name}Popup.html`];
      if (!popover) {
        popover = `${pathFilter(name, 'popup')}${name}Popup.html`;
      }

      scope.types.push({
        id: 'popoverBtn' + ang.getUniqueId(),
        name,
        title: i18nFilter('fe.core.popup.title.' + name),
        popover
      });
    }
    for (var i in scope.types) {
      var type = scope.types[i];
      var links = '';
      for (var ii in scope.types) {
        var t = scope.types[ii];
        if (ii != i) {
          // current and open other. Show the other button to get correct positioning
          links +=
            '<a onclick="' +
            "$('#" +
            type.id +
            "').click();$('#" +
            type.id +
            "').hide();" +
            "$('#" +
            t.id +
            "').show();$('#" +
            t.id +
            '\').click();">' +
            t.title +
            '</a>';
        }
      }
      type.links = links;
    }
    scope.onResult = function(ob) {
      ob.forEach(function(element) {
        scope.result()(element);
      });
    };
  }
}
